// Avada Cookie Consent + Shopify Customer Privacy API Integration
function gtag(){window.dataLayer.push(arguments)}

function getCookie(e){
  const t=e+"=",a=document.cookie.split(";");
  for(let e=0;e<a.length;e++){
    let n=a[e];
    for(;" "===n.charAt(0);)n=n.substring(1,n.length);
    if(0===n.indexOf(t))return JSON.parse(decodeURIComponent(n.substring(t.length,n.length)))
  }
  return{}
}

// Sync Avada consent to Shopify Customer Privacy API
// NOTE: Shopify requires this to be called during user interaction, not automatically
function syncAvadaToShopify(consent, isUserInteraction) {
  if (!isUserInteraction) {
    console.log('[Avada-Shopify Sync] Skipping - Shopify requires user interaction');
    return;
  }

  function trySync(attempts) {
    attempts = attempts || 0;

    if (window.Shopify?.customerPrivacy) {
      const shopifyConsent = {
        marketing: consent.marketing || false,
        analytics: consent.analytics || false,
        preferences: consent.functional || false,
        sale_of_data: consent.marketing || false
      };

      console.log('[Avada-Shopify Sync] 🔄 Syncing to Shopify:', shopifyConsent);

      window.Shopify.customerPrivacy.setTrackingConsent(
        shopifyConsent,
        function(error) {
          if (error) {
            console.error('[Avada-Shopify Sync] ✗ Sync failed:', error);
            return;
          }

          const newConsent = window.Shopify.customerPrivacy.currentVisitorConsent();
          console.log('[Avada-Shopify Sync] ✓ Synced! New consent:', newConsent);

          // Verify it worked
          if (newConsent && newConsent.preferences === shopifyConsent.preferences) {
            console.log('[Avada-Shopify Sync] ✓ Verified - consent persisted correctly!');
          } else {
            console.warn('[Avada-Shopify Sync] ⚠️  Warning: consent may not have persisted', {
              expected: shopifyConsent.preferences,
              actual: newConsent?.preferences
            });
          }
        }
      );
    } else if (attempts < 50) {
      console.log('[Avada-Shopify Sync] Waiting for Shopify API... (attempt ' + (attempts + 1) + ')');
      setTimeout(function() {
        trySync(attempts + 1);
      }, 100);
    } else {
      console.error('[Avada-Shopify Sync] ✗ Shopify API failed to load after 5 seconds');
    }
  }

  trySync();
}

const features=[{name:"consent-tracking-api",version:"0.1"}];
window.dataLayer=window.dataLayer||[];
window.AVADA_COOKIES_BAR=window.AVADA_COOKIES_BAR||{};
window.AVADA_COOKIE_CONSENT=getCookie("avada_cookie_consent");

window.Shopify?.loadFeatures&&window.Shopify.loadFeatures(features,(e=>{
  e&&console.error("Failed to load features",e)
}));

(()=>{
  let e=window.AVADA_COOKIE_CONSENT;

  if(!Object.keys(e).length){
    const t=!window.Shopify?.customerPrivacy||window.Shopify.customerPrivacy.shouldShowBanner();
    e={marketing:!t,analytics:!t,functional:!t}
  }

  console.log('[Avada-Shopify Sync] Avada consent:', e);

  // Set Google Consent Mode
  !e.marketing&&gtag("set","ads_data_redaction",!0);
  gtag("set","url_passthrough",!0);
  gtag("default",{
    ad_storage:e.marketing?"granted":"denied",
    ad_user_data:e.marketing?"granted":"denied",
    ad_personalization:e.marketing?"granted":"denied",
    analytics_storage:e.analytics?"granted":"denied",
    functionality_storage:e.functional?"granted":"denied",
    personalization_storage:e.functional?"granted":"denied",
    security_storage:"granted",
    wait_for_update:500
  });

  // Multiple ways to detect Avada user consent interactions

  // Method 1: Listen for custom Avada events
  window.addEventListener('avada_cookie_consent_accept', function(event) {
    console.log('[Avada-Shopify Sync] User accepted cookies via Avada event');
    const consent = getCookie('avada_cookie_consent');
    syncAvadaToShopify(consent, true);
  });

  window.addEventListener('avada_cookie_consent_update', function(event) {
    console.log('[Avada-Shopify Sync] User updated preferences via Avada event');
    const consent = getCookie('avada_cookie_consent');
    syncAvadaToShopify(consent, true);
  });

  // Method 2: Global callback for Avada (if it calls this)
  window.avadaConsentCallback = function(consent) {
    console.log('[Avada-Shopify Sync] Avada callback triggered');
    syncAvadaToShopify(consent, true);
  };

  // Method 3: Watch for Avada cookie bar disappearing (immediate detection)
  let syncAttempted = false;
  const observer = new MutationObserver(function(mutations) {
    // Check if Avada banner was removed
    const banner = document.querySelector('[class*="avada-cookie"], [id*="avada-cookie"]');

    if (!banner && !syncAttempted) {
      // Banner disappeared - user likely accepted/declined
      setTimeout(function() {
        const currentConsent = getCookie('avada_cookie_consent');
        if (Object.keys(currentConsent).length > 0) {
          console.log('[Avada-Shopify Sync] 🍪 Avada banner dismissed! Syncing consent...');
          syncAttempted = true;
          syncAvadaToShopify(currentConsent, true);
        }
      }, 100);  // Small delay to ensure cookie is written
    }
  });

  // Start observing body for changes
  if (document.body) {
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    console.log('[Avada-Shopify Sync] 👀 Watching for Avada banner dismissal');
  }

  // Method 4: Polling backup (in case observer misses it)
  let lastConsentValue = JSON.stringify(e);
  console.log('[Avada-Shopify Sync] Initial state:', e);

  setInterval(function() {
    const currentConsent = getCookie('avada_cookie_consent');
    const currentValue = JSON.stringify(currentConsent);

    if (currentValue !== lastConsentValue && Object.keys(currentConsent).length > 0 && !syncAttempted) {
      console.log('[Avada-Shopify Sync] 🍪 Cookie changed (polling detected)');
      lastConsentValue = currentValue;
      syncAttempted = true;
      syncAvadaToShopify(currentConsent, true);
    }
  }, 500);  // Check every 500ms (faster than before)
})();